import { BOOK_PLAYER_SET_DATA } from 'rebook/apps/base/constants';


const initialState = {
  bookId: null,
  availableForUser: false,
  showPlayer: false,
  rentBookPaymentLink: '',
};

const player = (state = initialState, action) => {
  switch (action.type) {
    case BOOK_PLAYER_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default player;
